/**
 * Require confirmation before closing the last open valve serving any running pump.
 * Each group contains the controllable sectors served by one running pump, including
 * sectors in other projects when a pump is shared. Already closed valves are harmless.
 */
export function isLastOpenValveForRunningPump(
  sectorId: string,
  runningPumpSectorGroups: readonly ReadonlySet<string>[],
  openSectorIds: ReadonlySet<string>
): boolean {
  if (!openSectorIds.has(sectorId)) return false;

  return runningPumpSectorGroups.some(
    (sectorIds) => sectorIds.has(sectorId) && ![...sectorIds].some((id) => id !== sectorId && openSectorIds.has(id))
  );
}
